<template>
    <section class="flex-container my-4">
        <h4 class="font-semibold">Informação do proprietário</h4>

        <div class="flex justify-between flex-wrap">
            <div class="flex items-center">
                <Icone :nome="'account_circle'" />
                <span class="">{{ nomeProprietario }}</span>
            </div>
            <div class="flex items-center flex-wrap gap-1">
                <PlacaMercosul :placa="placa" :tamanho="'media'" />       
            </div>
        </div>

        <div class="flex justify-between flex-wrap">
            <div class="flex items-center">
                <Icone :nome="'directions_car'" />
                <span class="">{{ modelo }}</span>
            </div>
            <div class="flex items-center">
                <Icone :nome="'format_paint'" />
                <span class="">{{ cor != '' ? cor : '-' }}</span>
            </div>
        </div>

        <div class="flex items-center">
            <Icone :nome="'call'" />
            <span class="text-azul-info">{{ telefoneSolicitante != '' ? telefoneSolicitante : '-' }}</span>
        </div>
    </section>
</template>

<script>
import { defineComponent } from 'vue';
import Icone from '@/components/Icone.vue';
import PlacaMercosul from './PlacaMercosul.vue';
export default defineComponent({
    name: 'InfoAtendimento',
    components: {
        Icone,
        PlacaMercosul
    },
    props: {
        nomeProprietario: {
            type: String,
            required: true
        },
        placa: {
            type: String,
            required: true
        },
        modelo: {
            type: String,
            required: true
        },
        cor: {
            type: String,
            required: true
        },
        telefoneSolicitante: {
            type: String,
            required: true
        }
    }
});
</script>